<template>
    <svg class="dark:text-gray-300" width="19" height="28" viewBox="0 0 19 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.72111 2.23191C6.98395 4.94283 4.5424 7.87311 1.99963 10.7631" stroke="#2C8BD1" stroke-width="2.5" stroke-linecap="round"/>
        <path d="M10.0943 2.00043C12.7565 4.78649 15.1094 7.77638 17.5668 10.7308" stroke="#2C8BD1" stroke-width="2.5" stroke-linecap="round"/>
        <path d="M10.0088 2.12207C9.90038 10.0133 9.94254 17.909 9.92358 25.8028" stroke="#2C8BD1" stroke-width="2.5" stroke-linecap="round"/>
    </svg>
</template>
